import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { getOrCreateAuditSessionCorrelationId } from "../services/audit-session.storage";

/**
 * Sends the same audit tab session id on every API call so server-side audit rows
 * (e.g. login success) share correlation_id with client-ingested events.
 */
@Injectable()
export class AuditCorrelationInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const base = environment.apiBaseUrl.replace(/\/$/, "");
    const url = req.url.split("?")[0];
    if (!url.startsWith(base)) {
      return next.handle(req);
    }

    const correlationId = getOrCreateAuditSessionCorrelationId();
    const cloned = req.clone({
      setHeaders: { "X-Correlation-Id": correlationId },
    });
    return next.handle(cloned);
  }
}
